import { render, staticRenderFns } from "./MainHeaderSearch.vue?vue&type=template&id=0533dc4a&scoped=true"
import script from "./MainHeaderSearch.vue?vue&type=script&lang=js"
export * from "./MainHeaderSearch.vue?vue&type=script&lang=js"
import style0 from "./MainHeaderSearch.vue?vue&type=style&index=0&id=0533dc4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0533dc4a",
  null
  
)

export default component.exports